import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
export default class ForumNav extends Component {
  view(vnode) {
    return m("div", {
      className: "BlogForumNav BlogSideWidget"
    }, m("h3", null, app.translator.trans('fof-blog.forum.forum_nav')), m("nav", {
      className: "IndexPage-nav sideNav"
    }, m(SelectDropdown, {
      buttonClassName: "Button",
      className: "App-titleControl"
    }, this.navItems().toArray())));
  }
  navItems() {
    return IndexSidebar.prototype.navItems();
  }
}
flarum.reg.add('fof-blog', 'forum/components/ForumNav', ForumNav);